"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var _extractChildren = _interopRequireDefault(require("@paprika/helpers/lib/extractChildren"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _Description = _interopRequireDefault(require("./components/Description"));

var _Instructions = _interopRequireDefault(require("./components/Instructions"));

var _Content = _interopRequireDefault(require("./components/Content"));

var _ErrorMessage = _interopRequireDefault(require("./components/ErrorMessage"));

var _Help = _interopRequireDefault(require("./components/Help"));

var _Label = _interopRequireDefault(require("./components/Label"));

var sc = _interopRequireWildcard(require("./FormElement.styles"));

var subComponentDisplayNames = {
  Error: "FormElement.Error",
  Description: "FormElement.Description",
  Content: "FormElement.Content",
  Instructions: "FormElement.Instructions",
  Help: "FormElement.Help"
};

function FormElement(props) {
  var children = props.children,
      hasOptionalLabel = props.hasOptionalLabel,
      hasRequiredLabel = props.hasRequiredLabel,
      id = props.id,
      isDisabled = props.isDisabled,
      isInline = props.isInline,
      isLabelVisuallyHidden = props.isLabelVisuallyHidden,
      label = props.label,
      size = props.size,
      hasFieldSet = props.hasFieldSet,
      onClickLabel = props.onClickLabel,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "hasOptionalLabel", "hasRequiredLabel", "id", "isDisabled", "isInline", "isLabelVisuallyHidden", "label", "size", "hasFieldSet", "onClickLabel"]);
  var extractedChildren = (0, _extractChildren["default"])(children, (0, _values["default"])(subComponentDisplayNames));

  var ariaDescriptionId = _react["default"].useRef((0, _v["default"])()).current;

  var ariaErrorId = _react["default"].useRef((0, _v["default"])()).current;

  var ariaInstructionsId = _react["default"].useRef((0, _v["default"])()).current;

  var uniqueInputId = _react["default"].useRef((0, _v["default"])()).current;

  var hasError = !!extractedChildren[subComponentDisplayNames.Error] && !!extractedChildren[subComponentDisplayNames.Error].props.children;

  var generateLabelId = function generateLabelId(id) {
    return (0, _isNil["default"])(id) || id === "" ? uniqueInputId : id;
  };

  var idForLabel = generateLabelId(id);

  var refLabel = _react["default"].useRef(null);

  var getClonedElement = function getClonedElement(displayName) {
    var extraProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!extractedChildren[displayName]) return null;
    return /*#__PURE__*/_react["default"].cloneElement(extractedChildren[displayName], extraProps);
  };

  function renderFooter() {
    if (hasError) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        role: "alert"
      }, getClonedElement(subComponentDisplayNames.Error, {
        id: ariaErrorId
      }));
    }

    if (extractedChildren[subComponentDisplayNames.Description]) {
      return getClonedElement(subComponentDisplayNames.Description, {
        id: ariaDescriptionId
      });
    }

    return null;
  }

  function renderContent() {
    return getClonedElement(subComponentDisplayNames.Content, {
      idForLabel: idForLabel,
      refLabel: refLabel,
      ariaDescribedBy: "".concat(ariaErrorId, " ").concat(ariaInstructionsId, " ").concat(ariaDescriptionId)
    });
  }

  function renderInstructions() {
    return getClonedElement(subComponentDisplayNames.Instructions, {
      id: ariaInstructionsId
    });
  }

  return /*#__PURE__*/_react["default"].createElement(sc.FormElement, (0, _extends2["default"])({
    as: hasFieldSet ? "fieldset" : "div",
    isInline: isInline,
    size: size,
    isDisabled: isDisabled
  }, moreProps), /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    hasOptionalLabel: hasRequiredLabel ? false : hasOptionalLabel,
    hasRequiredLabel: hasRequiredLabel,
    help: extractedChildren[subComponentDisplayNames.Help],
    id: idForLabel,
    isInline: isInline,
    isVisuallyHidden: isLabelVisuallyHidden,
    label: label,
    ref: refLabel,
    hasFieldSet: hasFieldSet,
    onClick: onClickLabel
  }), /*#__PURE__*/_react["default"].createElement(sc.Sections, {
    isInline: isInline
  }, renderInstructions(), renderContent(), renderFooter()));
}

FormElement.types = {
  size: constants.defaultSize
};
var propTypes = {
  children: _propTypes["default"].node.isRequired,

  /** Should show is optional text besides the label or not. Will not show if hasRequiredLabel prop is true */
  hasOptionalLabel: _propTypes["default"].bool,

  /** Should show is required text besides the label or not. Takes presendence over hasOptionalLabel prop */
  hasRequiredLabel: _propTypes["default"].bool,

  /** ID for the child element. */
  id: _propTypes["default"].string,

  /** Should be disabled or not, default is false. */
  isDisabled: _propTypes["default"].bool,

  /** Should label and children be inline or not, default is false. */
  isInline: _propTypes["default"].bool,

  /** Should label be hidden, default is false. Note: this is discouraged because of accessibility requirements. */
  isLabelVisuallyHidden: _propTypes["default"].bool,

  /** Label text of this field. */
  label: _propTypes["default"].node.isRequired,

  /** Size of the label, error, help and description (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([FormElement.types.size.SMALL, FormElement.types.size.MEDIUM, FormElement.types.size.LARGE]),

  /** FormElement contains multiple children so Renders a legend element instead of label. */
  hasFieldSet: _propTypes["default"].bool,
  onClickLabel: _propTypes["default"].func
};
var defaultProps = {
  hasOptionalLabel: false,
  hasRequiredLabel: false,
  id: null,
  isDisabled: false,
  isInline: false,
  isLabelVisuallyHidden: false,
  size: FormElement.types.size.MEDIUM,
  hasFieldSet: false,
  onClickLabel: function onClickLabel() {}
};
FormElement.displayName = "FormElement";
FormElement.propTypes = propTypes;
FormElement.defaultProps = defaultProps;
FormElement.subComponentDisplayNames = subComponentDisplayNames;
FormElement.Content = _Content["default"];
FormElement.Instructions = _Instructions["default"];
FormElement.Description = _Description["default"];
FormElement.Error = _ErrorMessage["default"];
FormElement.Help = _Help["default"];
var _default = FormElement;
exports["default"] = _default;
//# sourceMappingURL=FormElement.js.map